<template>
    <DForm @submit.prevent="submitForm">
        <DCard
            :title="__('settings.sepa_provider_settings.sepa_settings')"
            padding
            class="mb-3"
        >
            <DFormRow
                :label="__('settings.sepa_provider_settings.sepa_provider')"
                :is-required="true"
                :error="errorsData['sepa_provider']"
                :hint="__('settings.sepa_provider_settings.sepa_provider_hint')"
            >
                <DSelect
                    id="sepa_provider"
                    v-model="form.sepa_provider"
                    :options="sepaProviders"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.limit_file_size')"
                :is-required="true"
                :error="errorsData['limit_file_size']"
                :hint="__('settings.sepa_provider_settings.form.limit_file_size_hint')"
            >
                <DSwitch
                    id="limit_file_size"
                    v-model="form.limit_file_size"
                    color="success"
                    variant="3d"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.use_batch_booking_for_collection')"
                :is-required="true"
                :error="errorsData['use_batch_booking_for_collection']"
                :hint="__('settings.sepa_provider_settings.form.use_batch_booking_for_collection_hint')"
            >
                <DSwitch
                    id="use_batch_booking_for_collection"
                    v-model="form.use_batch_booking_for_collection"
                    color="success"
                    variant="3d"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.use_batch_booking_for_payments')"
                :is-required="true"
                :error="errorsData['use_batch_booking_for_payments']"
                :hint="__('settings.sepa_provider_settings.form.use_batch_booking_for_payments_hint')"
            >
                <DSwitch
                    id="use_batch_booking_for_payments"
                    v-model="form.use_batch_booking_for_payments"
                    color="success"
                    variant="3d"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.automatic_upload')"
                :is-required="true"
                :error="errorsData['automatic_upload']"
                :hint="__('settings.sepa_provider_settings.form.automatic_upload_hint')"
            >
                <DSwitch
                    id="automatic_upload"
                    v-model="form.automatic_upload"
                    color="success"
                    variant="3d"
                />
            </DFormRow>
        </DCard>
        <DCard
            v-if="form.automatic_upload"
            :title="__(`settings.sepa_provider_settings.providers.${form.sepa_provider}`)"
            padding
        >
            <DFormRow
                v-if="isCobase"
                :label="__('settings.sepa_provider_settings.form.payment_status_location')"
                :is-required="true"
                :error="errorsData['payment_status_location']"
                :hint="__('settings.sepa_provider_settings.form.import_location_hint')"
            >
                <DInput
                    id="payment_status_location"
                    v-model="form.payment_status_location"
                    :placeholder="__('settings.sepa_provider_settings.form.payment_status_location')"
                    :is-valid="isFormFieldValid('payment_status_location')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                v-if="isCobase"
                :label="__('settings.sepa_provider_settings.form.reporting_statements_location')"
                :is-required="true"
                :error="errorsData['reporting_statements_location']"
                :hint="__('settings.sepa_provider_settings.form.reporting_statements_location_hint')"
            >
                <DInput
                    id="reporting_statements_location"
                    v-model="form.reporting_statements_location"
                    :placeholder="__('settings.sepa_provider_settings.form.reporting_statements_location')"
                    :is-valid="isFormFieldValid('reporting_statements_location')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.export_location')"
                :is-required="isCobase"
                :error="errorsData['export_location']"
                :hint="__('settings.sepa_provider_settings.form.export_location_hint')"
            >
                <DInput
                    id="export_location"
                    v-model="form.export_location"
                    :placeholder="__('settings.sepa_provider_settings.form.export_location')"
                    :is-valid="isFormFieldValid('export_location')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                v-if="isCobase"
                :label="__('settings.sepa_provider_settings.form.archive_location')"
                :is-required="true"
                :error="errorsData['archive_location']"
                :hint="__('settings.sepa_provider_settings.form.archive_location_hint')"
            >
                <DInput
                    id="archive_location"
                    v-model="form.archive_location"
                    :placeholder="__('settings.sepa_provider_settings.form.archive_location')"
                    :is-valid="isFormFieldValid('archive_location')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                v-if="isCobase"
                :label="__('settings.sepa_provider_settings.form.error_location')"
                :is-required="true"
                :error="errorsData['error_location']"
                :hint="__('settings.sepa_provider_settings.form.error_location_hint')"
            >
                <DInput
                    id="error_location"
                    v-model="form.error_location"
                    :placeholder="__('settings.sepa_provider_settings.form.error_location')"
                    :is-valid="isFormFieldValid('error_location')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.key')"
                :is-required="true"
                :error="errorsData['key']"
                :hint="__('settings.sepa_provider_settings.form.key_hint')"
            >
                <DInput
                    id="key"
                    v-model="form.key"
                    :placeholder="__('settings.sepa_provider_settings.form.key')"
                    :is-valid="isFormFieldValid('key')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.secret')"
                :is-required="true"
                :error="errorsData['secret']"
                :hint="__('settings.sepa_provider_settings.form.secret_hint')"
            >
                <DInput
                    id="secret"
                    v-model="form.secret"
                    :placeholder="__('settings.sepa_provider_settings.form.secret')"
                    :is-valid="isFormFieldValid('secret')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.region')"
                :is-required="true"
                :error="errorsData['region']"
                :hint="__('settings.sepa_provider_settings.form.region_hint')"
            >
                <DInput
                    id="region"
                    v-model="form.region"
                    :placeholder="__('settings.sepa_provider_settings.form.region')"
                    :is-valid="isFormFieldValid('region')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.bucket')"
                :is-required="true"
                :error="errorsData['bucket']"
                :hint="__('settings.sepa_provider_settings.form.bucket_hint')"
            >
                <DInput
                    id="bucket"
                    v-model="form.bucket"
                    :placeholder="__('settings.sepa_provider_settings.form.bucket')"
                    :is-valid="isFormFieldValid('bucket')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.url')"
                :error="errorsData['url']"
                :hint="__('settings.sepa_provider_settings.form.url_hint')"
            >
                <DInput
                    id="url"
                    v-model="form.url"
                    :placeholder="__('settings.sepa_provider_settings.form.url')"
                    :is-valid="isFormFieldValid('url')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.endpoint')"
                :is-required="true"
                :error="errorsData['endpoint']"
                :hint="__('settings.sepa_provider_settings.form.endpoint_hint')"
            >
                <DInput
                    id="endpoint"
                    v-model="form.endpoint"
                    :placeholder="__('settings.sepa_provider_settings.form.endpoint')"
                    :is-valid="isFormFieldValid('endpoint')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_provider_settings.form.use_path_style_endpoint')"
                :is-required="true"
                :error="errorsData['use_path_style_endpoint']"
                :hint="__('settings.sepa_provider_settings.form.use_path_style_endpoint_hint')"
            >
                <DSwitch
                    id="use_path_style_endpoint"
                    v-model="form.use_path_style_endpoint"
                    color="success"
                    variant="3d"
                />
            </DFormRow>
            <!-- A blank label keeps the button in the same grid column as the inputs above it, so it
                 lines up under the "use path style endpoint" switch. -->
            <DFormRow label=" ">
                <DButton
                    icon="lan-connect"
                    :label="__('settings.sepa_provider_settings.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
                <div
                    v-if="connectionStatus === 'successful'"
                    class="text-success mt-2"
                >
                    {{ __('settings.sepa_provider_settings.connection_successful') }}
                </div>
                <div
                    v-if="connectionStatus === 'unsuccessful'"
                    class="text-danger mt-2"
                >
                    {{ __('settings.sepa_provider_settings.connection_unsuccessful') }}
                </div>
            </DFormRow>
        </DCard>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { computed, ref, watch } from 'vue'

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

const props = defineProps({
    provider: {
        type: String,
        default: 'windata'
    },
    sepaProviders: {
        type: Array,
        default: () => { return [] }
    },
    sepaSettings: {
        type: Object,
        default: () => ({})
    },
    windataSettings: {
        type: Object,
        default: () => ({})
    },
    cobaseSettings: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const emit = defineEmits(['form-submitted'])

const settingsForProvider = (provider) => {
    return provider === 'cobase' ? props.cobaseSettings : props.windataSettings
}

const providerSettings = settingsForProvider(props.provider)

const credentialsValid = ref(false)
const connectionException = ref(null)
const errorsData = ref(props.errors)
const connectionStatus = ref('')

const form = useForm({
    sepa_provider: props.provider,
    payment_status_location: providerSettings?.payment_status_location ?? null,
    reporting_statements_location: providerSettings?.reporting_statements_location ?? null,
    export_location: providerSettings?.export_location ?? null,
    archive_location: providerSettings?.archive_location ?? null,
    error_location: providerSettings?.error_location ?? null,
    key: providerSettings?.key ?? null,
    secret: providerSettings?.secret ?? null,
    region: providerSettings?.region ?? null,
    bucket: providerSettings?.bucket ?? null,
    url: providerSettings?.url ?? null,
    endpoint: providerSettings?.endpoint ?? null,
    use_path_style_endpoint: providerSettings?.use_path_style_endpoint ?? false,
    automatic_upload: props.sepaSettings?.automatic_upload ?? false,
    limit_file_size: props.sepaSettings?.limit_file_size ?? false,
    use_batch_booking_for_collection: props.sepaSettings?.use_batch_booking_for_collection ?? false,
    use_batch_booking_for_payments: props.sepaSettings?.use_batch_booking_for_payments ?? false
})

const isCobase = computed(() => form.sepa_provider === 'cobase')

const connectionCredentials = computed(() => {
    return JSON.stringify([
        form.key,
        form.secret,
        form.region,
        form.bucket,
        form.endpoint,
        form.use_path_style_endpoint
    ])
})

// A submit keeps the component mounted (Inertia posts with preserveState), so setup() does not run
// again and the errors have to be taken from the refreshed prop.
watch(() => props.errors, (errors) => {
    errorsData.value = errors
})

// A successful check only proves that the credentials it was given work, so editing any of
// them hides the save controls again until the connection has been checked anew.
watch(connectionCredentials, () => {
    credentialsValid.value = false
    connectionStatus.value = ''
})

// The file settings are shared, so switching provider only reloads the connection fields
// with whatever is already stored for the newly selected one.
watch(() => form.sepa_provider, (provider) => {
    const settings = settingsForProvider(provider)

    form.payment_status_location = settings?.payment_status_location ?? null
    form.reporting_statements_location = settings?.reporting_statements_location ?? null
    form.export_location = settings?.export_location ?? null
    form.archive_location = settings?.archive_location ?? null
    form.error_location = settings?.error_location ?? null
    form.key = settings?.key ?? null
    form.secret = settings?.secret ?? null
    form.region = settings?.region ?? null
    form.bucket = settings?.bucket ?? null
    form.url = settings?.url ?? null
    form.endpoint = settings?.endpoint ?? null
    form.use_path_style_endpoint = settings?.use_path_style_endpoint ?? false
})

const submitForm = () => {
    emit('form-submitted', form)
}

const checkConnection = () => {
    connectionException.value = null
    errorsData.value = {}

    window.axios.post(route('settings.sepa-settings.check'), form.data())
        .then(() => {
            connectionStatus.value = 'successful'
            credentialsValid.value = true
        })
        .catch((error) => {
            connectionStatus.value = 'unsuccessful'
            credentialsValid.value = false

            if (error.response.data.errors !== undefined) {
                errorsData.value = error.response.data.errors

                for (const key in errorsData.value) {
                    if (typeof errorsData.value[key] === 'object') {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }

            if (error?.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        })
}

const closeErrorCheckModal = () => {
    connectionException.value = null
}
</script>
